<script setup lang="ts">
import { SEARCH_INPUT_ID } from "@/constants/misc";

const emit = defineEmits<{
  (e: "enter-search-result", input: SearchHistoryItem): void;
}>();

const { searchHistory, clearSearchHistory } = useSearchHistory();

const { recentSearchItemClicked } = useAnalytics();

const onRecentSearchItemClicked = (searchTerm: SearchHistoryItem) => {
  recentSearchItemClicked({ search_term: getSearchHistoryName(searchTerm) });
  emit("enter-search-result", searchTerm);
};

const onClearSearchHistoryClicked = () => {
  clearSearchHistory();
  document.getElementById(SEARCH_INPUT_ID)?.focus();
};
</script>

<template>
  <div>
    <div class="flex flex-row justify-between mb-3">
      <h2 class="uppercase text-base font-semibold">
        {{ $t("quickSearch.recentSearches") }}
      </h2>
      <button
        class="font-bold uppercase text-base !p-0"
        @click="onClearSearchHistoryClicked"
      >
        {{ $t("quickSearch.clear") }}
      </button>
    </div>
    <ul>
      <li
        v-for="searchTerm in searchHistory"
        :key="getSearchHistoryName(searchTerm)"
        type="button"
        class="py-1 flex items-center truncate text-base hover:font-semibold"
        data-test="search-history-item"
      >
        <button @click="onRecentSearchItemClicked(searchTerm)">
          {{ getSearchHistoryName(searchTerm) }}
        </button>
      </li>
    </ul>
  </div>
</template>
